import { useEffect, useState } from "react";
import { listGallery, fileUrl } from "../lib/api";
import { MapPin, Calendar } from "lucide-react";

export function GallerySection() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    listGallery().then(setItems).catch(console.error);
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <section
      data-testid="gallery-section"
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20"
    >
      <div className="mb-10 flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-primary mb-3">Our Work</div>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight leading-none">
            Solar projects gallery
          </h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            A quick look at the rooftop and commercial installations completed by our team.
          </p>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((it, i) => (
          <article
            key={it.id}
            data-testid={`gallery-item-${it.id}`}
            className={`group bg-white border border-border rounded-2xl overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all ${
              i % 5 === 0 ? "lg:col-span-2 lg:row-span-1" : ""
            }`}
          >
            <div className={`bg-muted overflow-hidden ${i % 5 === 0 ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
              <img
                src={fileUrl(it.image_url)}
                alt={it.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4 sm:p-6">
              <div className="font-heading text-lg sm:text-xl font-semibold leading-snug mb-2">
                {it.title}
              </div>
              {it.description && (
                <p className="text-sm text-muted-foreground line-clamp-3 leading-relaxed mb-4">
                  {it.description}
                </p>
              )}
              <div className="flex flex-wrap gap-4 text-xs text-secondary">
                {it.location && (
                  <div className="inline-flex items-center gap-1.5">
                    <MapPin className="w-3.5 h-3.5 text-primary" strokeWidth={2} />
                    <span>{it.location}</span>
                  </div>
                )}
                {it.project_date && (
                  <div className="inline-flex items-center gap-1.5">
                    <Calendar className="w-3.5 h-3.5 text-primary" strokeWidth={2} />
                    <span>{it.project_date}</span>
                  </div>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
